/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSsoProviderFromJSON, StreemApiSsoProviderToJSON, } from './';
export function StreemApiListSsoProvidersResponseFromJSON(json) {
    return StreemApiListSsoProvidersResponseFromJSONTyped(json, false);
}
export function StreemApiListSsoProvidersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ssoProviders': !exists(json, 'sso_providers') ? undefined : (json['sso_providers'].map(StreemApiSsoProviderFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListSsoProvidersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sso_providers': value.ssoProviders === undefined ? undefined : (value.ssoProviders.map(StreemApiSsoProviderToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListSsoProvidersResponse.js.map